module.exports = __webpack_public_path__ + "img/success-icon-blue.72d45430.png";